package com.karyadina.web

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.karyadina.di.initKoinWeb
import com.karyadina.service.AppStorage
import com.karyadina.service.WebKeyValueStorage
import com.karyadina.ui.App
import com.karyadina.ui.screens.cloudsync.LocalCloudSyncSettingsProvider
import com.karyadina.web.ui.WebCloudSyncCard
import com.karyadina.cloudsync.service.SharedLinkService
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject
import kotlinx.serialization.json.Json
import androidx.compose.runtime.CompositionLocalProvider

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    // Initialize persistent storage for web
    AppStorage.initialize(WebKeyValueStorage())
    initKoinWeb()
    // Set body styles programmatically for proper layout
    document.body!!.style.apply {
        setProperty("width", "100vw")
        setProperty("height", "100vh")
        setProperty("margin", "0")
        setProperty("padding", "0")
        setProperty("overflow", "hidden")
        setProperty("display", "flex")
    }
    
    // Handle ?share= token
    val urlParams = window.location.search
    if (urlParams.contains("?share=")) {
        val token = urlParams.substringAfter("?share=").substringBefore("&")
        if (token.isNotEmpty()) {
            val koinContext = object : KoinComponent {
                val sharedLinkService: SharedLinkService by inject()
            }
            MainScope().launch {
                val result = koinContext.sharedLinkService.getSharedItem(token)
                if (result.isSuccess) {
                    val sharedContent = result.getOrThrow()
                    try {
                        val mapData = Json.decodeFromString<Map<String, String>>(sharedContent.content)
                        AppStorage.get().importAll(mapData)
                        window.alert("Successfully imported shared data snapshot! The app will now reload.")
                        // Reload without the ?share= param so UI picks up the new data
                        window.location.href = window.location.origin + window.location.pathname
                    } catch (e: Exception) {
                        window.alert("Failed to parse shared data")
                    }
                } else {
                    window.alert("Invalid or expired share link")
                }
            }
        }
    }

    ComposeViewport(document.body!!) {
        CompositionLocalProvider(
            LocalCloudSyncSettingsProvider provides { WebCloudSyncCard() }
        ) {
            App()
        }
    }
}
